// extracted by mini-css-extract-plugin
export var card = "_bd-c";
export var checkmark = "_bd-k";
export var childrenContainer = "_bd-6";
export var container = "_bd-b";
export var disabled = "_bd-9";
export var disabledChildren = "_bd-a";
export var focused = "_bd-1";
export var gray = "_bd-s";
export var green = "_bd-p";
export var icon = "_bd-g";
export var iconWrapper = "_bd-8";
export var imageCircle = "_bd-u";
export var large = "_bd-5";
export var lg = "_bd-j";
export var listItemContainer = "_bd-0";
export var md = "_bd-i";
export var medium = "_bd-4";
export var menu = "_bd-f";
export var nonInteractiveBadge = "_bd-m";
export var red = "_bd-q";
export var rightArea = "_bd-7";
export var sectionContainer = "_bd-e _bd-b";
export var selected = "_bd-d";
export var sm = "_bd-h";
export var small = "_bd-3";
export var statusDot = "_bd-o";
export var statusDotContainer = "_bd-n";
export var text = "_bd-l";
export var transparent = "_bd-t";
export var xs = "_bd-2";
export var yellow = "_bd-r";